if (!customElements.get("variant-picker")) {
  // Versión del script para control de caché
  const SCRIPT_VERSION = '1.4.6';
  
  // Variable GLOBAL para preservar estado expandido entre recreaciones de componentes
  window.variantPickerExpandedState = window.variantPickerExpandedState || {};
  
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      
      // Inicializar el componente
      this.initEventListeners();
      
      // Intentar inicializar componentes ahora, pero también se inicializarán cuando el DOM esté listo
      this.initComponents();
    }
    
    // Inicializar todos los componentes
    initComponents() {
      try {
        // Inicializar slider de sabores si existe
        this.initSliders();
        
        // Actualizar etiquetas seleccionadas
        this.updateSelectedLabels();
      } catch (error) {
        console.error('[VariantPicker] Error al inicializar componentes:', error);
      }
    }

    // Obtener valores de opciones seleccionadas
    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    // Inicializar eventos
    initEventListeners() {
      // Escuchar cambios en las opciones
      this.addEventListener('change', (event) => {
        // Al cambiar una opción, guarda el estado de los sliders
        this.saveSliderPositions();
        
        const target = this.getInputForEventTarget(event.target);
        
        // Actualizar etiquetas de selección
        this.updateSelectedLabels();
        
        // Emitir evento para otros componentes (esto actualiza la imagen del producto)
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { 
          data: { 
            selectedOptionValues: this.selectedOptionValues, 
            event, 
            target 
          } 
        });
        
        // Restaurar posiciones del slider después del cambio
        setTimeout(() => {
          this.restoreSliderPositions();
        }, 400);
      });
      
      // Inicializar componentes cuando el DOM esté completamente cargado
      document.addEventListener('DOMContentLoaded', () => {
        // Reinicializar componentes cuando el DOM esté listo
        setTimeout(() => {
          this.initComponents();
        }, 100);
      });
    }

    // Obtener el input para el target del evento
    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
    
    // Actualizar las etiquetas con los valores seleccionadas
    updateSelectedLabels() {
      try {
        // Buscar todas las opciones
        const optionContainers = this.querySelectorAll('.m-product-option');
        
        optionContainers.forEach(container => {
          // Encontrar el campo de selección
          const pickerField = container.querySelector('[data-picker-field]');
          if (!pickerField) return;
          
          // Obtener el valor seleccionado
          let selectedValue = '';
          
          if (pickerField.dataset.pickerField === 'radio') {
            const checkedInput = pickerField.querySelector('input:checked');
            if (checkedInput) {
              selectedValue = checkedInput.value;
            }
          } else if (pickerField.dataset.pickerField === 'select') {
            const select = pickerField.querySelector('select');
            if (select && select.selectedOptions.length > 0) {
              selectedValue = select.selectedOptions[0].value;
            }
          }
          
          // Actualizar la etiqueta con el valor seleccionado
          if (selectedValue) {
            const selectedLabel = container.querySelector('.option-label--selected');
            if (selectedLabel) {
              selectedLabel.textContent = selectedValue;
            }
          }
        });
      } catch (error) {
        console.error('[VariantPicker] Error actualizando etiquetas:', error);
      }
    }
    
    // Inicializar sliders para sabores
    initSliders() {
      try {
        // Encontrar contenedores de sabor por clase o atributo data-option-name
        const saborContainersByClass = this.querySelectorAll('.m-product-option--sabor');
        const saborContainersByName = this.querySelectorAll('.m-product-option[data-option-name*="abor"]');
        
        let saborContainers = Array.from(saborContainersByClass);
        
        // Añadir contenedores encontrados por nombre que no estén ya en la lista
        Array.from(saborContainersByName).forEach(container => {
          if (!saborContainers.includes(container)) {
            saborContainers.push(container);
          }
        });
        
        if (saborContainers.length === 0) {
          // Buscar buscando en el atributo data-option-name de los elementos hijos
          const allOptions = this.querySelectorAll('.m-product-option');
          allOptions.forEach(option => {
            const optionNameElement = option.querySelector('[data-option-name]');
            if (optionNameElement && 
                (optionNameElement.dataset.optionName.toLowerCase().includes('sabor') || 
                 optionNameElement.dataset.optionName.includes('Sabor'))) {
              if (!saborContainers.includes(option)) {
                saborContainers.push(option);
                option.classList.add('m-product-option--sabor');
              }
            }
          });
        }
        
        if (saborContainers.length === 0) {
          return;
        }
        
        // Aplicar slider a cada contenedor de sabor
        saborContainers.forEach(container => {
          this.setupSlider(container);
        });
        
        // Configurar botón "Ver todos"
        this.setupViewAllButtons();
      } catch (error) {
        console.error('[VariantPicker] Error inicializando sliders:', error);
      }
    }
    
    // Configurar un slider específico
    setupSlider(container) {
      try {
        // Encontrar contenedor de opciones
        const sliderContainer = container.querySelector('.m-product-option--slider-container');
        if (!sliderContainer) {
          return;
        }
        
        // Encontrar wrapper del slider
        const sliderWrapper = container.querySelector('.m-product-option--slider-wrapper');
        if (!sliderWrapper) {
          return;
        }
        
        // Encontrar el slider
        const slider = container.querySelector('.m-product-option--slider');
        if (!slider) {
          return;
        }
        
        // Configurar navegación con flechas
        const prevButton = container.querySelector('.m-product-option--slider-prev');
        if (prevButton) {
          prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            sliderWrapper.scrollBy({
              left: -sliderWrapper.offsetWidth / 2,
              behavior: 'smooth'
            });
          });
        }
        
        const nextButton = container.querySelector('.m-product-option--slider-next');
        if (nextButton) {
          nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            sliderWrapper.scrollBy({
              left: sliderWrapper.offsetWidth / 2,
              behavior: 'smooth'
            });
          });
        }
        
        // Configurar arrastre (drag) del slider
        let isDragging = false;
        let startX, scrollLeft;
        
        sliderWrapper.addEventListener('mousedown', (e) => {
          if (e.button !== 0) return; // Solo clic izquierdo
          isDragging = true;
          sliderWrapper.style.cursor = 'grabbing';
          startX = e.pageX - sliderWrapper.offsetLeft;
          scrollLeft = sliderWrapper.scrollLeft;
          e.preventDefault();
        });
        
        sliderWrapper.addEventListener('mousemove', (e) => {
          if (!isDragging) return;
          const x = e.pageX - sliderWrapper.offsetLeft;
          const walk = (x - startX) * 1.5;
          sliderWrapper.scrollLeft = scrollLeft - walk;
          e.preventDefault();
        });
        
        const endDrag = () => {
          isDragging = false;
          sliderWrapper.style.cursor = 'grab';
        };
        
        sliderWrapper.addEventListener('mouseup', endDrag);
        sliderWrapper.addEventListener('mouseleave', endDrag);
        
        // Soporte táctil
        sliderWrapper.addEventListener('touchstart', (e) => {
          isDragging = true;
          startX = e.touches[0].pageX - sliderWrapper.offsetLeft;
          scrollLeft = sliderWrapper.scrollLeft;
        });
        
        sliderWrapper.addEventListener('touchmove', (e) => {
          if (!isDragging) return;
          const x = e.touches[0].pageX - sliderWrapper.offsetLeft;
          const walk = (x - startX) * 1.5;
          sliderWrapper.scrollLeft = scrollLeft - walk;
        });
        
        sliderWrapper.addEventListener('touchend', endDrag);
      } catch (error) {
        console.error('[VariantPicker] Error configurando slider:', error);
      }
    }
    
    // Configurar botones "Ver todos"
    setupViewAllButtons() {
      try {
        const viewAllButtons = this.querySelectorAll('.view-all-button');
        
        viewAllButtons.forEach(button => {
          // Eliminar eventos anteriores para evitar duplicación
          const newButton = button.cloneNode(true);
          button.parentNode.replaceChild(newButton, button);
          
          // Añadir el nuevo event listener utilizando una función de flecha para preservar el contexto
          newButton.addEventListener('click', (e) => {
            e.preventDefault();
            
            // Obtener elementos
            const container = newButton.closest('.m-product-option--sabor');
            if (!container) return;
            
            const isExpanded = container.classList.contains('expanded');
            const expandedView = container.querySelector('.sabor-expanded-view');
            const sliderContainer = container.querySelector('.m-product-option--slider-container');
            
            
            // Crear la vista expandida si no existe
            if (!expandedView) {
              this.handleViewAllButtonClick(e);
              return;
            }
            
            // Alternar estado
            if (isExpanded) {
              // Cerrar
              newButton.textContent = 'Ver todos';
              container.classList.remove('expanded');
              expandedView.style.display = 'none';
              expandedView.style.visibility = 'hidden';
              expandedView.style.opacity = '0';
              expandedView.style.position = 'absolute';
              expandedView.style.height = '0';
              expandedView.style.overflow = 'hidden';
              expandedView.style.margin = '0';
              expandedView.style.padding = '0';
              if (sliderContainer) sliderContainer.style.display = '';
              
              // RESETEAR variable GLOBAL cuando se cierra manualmente
              const productId = this.dataset.productId || 'default';
              window.variantPickerExpandedState[productId] = false;
            } else {
              // Abrir
              newButton.textContent = 'Ver menos';
              container.classList.add('expanded');
              expandedView.style.display = 'flex';
              expandedView.style.visibility = 'visible';
              expandedView.style.opacity = '1';
              expandedView.style.position = 'static';
              expandedView.style.height = 'auto';
              expandedView.style.overflow = 'visible';
              expandedView.style.marginTop = '10px';
              expandedView.style.padding = '0';
              if (sliderContainer) sliderContainer.style.display = 'none';
              
              // GUARDAR estado expandido en variable GLOBAL
              const productId = this.dataset.productId || 'default';
              window.variantPickerExpandedState[productId] = true;
            }
            
            // Registrar el nuevo estado
            
            e.stopPropagation();
          });
          
          // Configuración inicial - PRESERVAR estado expandido si ya existe
          const container = newButton.closest('.m-product-option--sabor');
          if (container) {
            // VERIFICAR LA VARIABLE GLOBAL (sobrevive a recreaciones del componente)
            const productId = this.dataset.productId || 'default';
            const globalExpanded = window.variantPickerExpandedState[productId] === true;
            const domExpanded = container.classList.contains('expanded');
            const wasExpanded = domExpanded || globalExpanded;
            const expandedView = container.querySelector('.sabor-expanded-view');
            const sliderContainer = container.querySelector('.m-product-option--slider-container');
            
            
            // Solo cerrar si NO está expandido actualmente
            if (!wasExpanded) {
              container.classList.remove('expanded');
              
              if (expandedView) {
                expandedView.style.display = 'none';
                expandedView.style.visibility = 'hidden';
                expandedView.style.opacity = '0';
                expandedView.style.position = 'absolute';
                expandedView.style.height = '0';
                expandedView.style.overflow = 'hidden';
                expandedView.style.margin = '0';
                expandedView.style.padding = '0';
              }
              
              if (sliderContainer) {
                sliderContainer.style.display = '';
              }
              
              // Asegurar que el botón dice "Ver todos"
              newButton.textContent = 'Ver todos';
            } else {
              // Mantener expandido y asegurar que el botón dice "Ver menos"
              
              // APLICAR LA CLASE EXPANDED
              container.classList.add('expanded');
              newButton.textContent = 'Ver menos';
              
              // VERIFICAR si existe la vista expandida
              
              // ASEGURAR que los estilos se mantienen
              if (expandedView) {
                expandedView.style.display = 'flex';
                expandedView.style.visibility = 'visible';
                expandedView.style.opacity = '1';
                expandedView.style.position = 'static';
                expandedView.style.height = 'auto';
                expandedView.style.overflow = 'visible';
                expandedView.style.marginTop = '10px';
                expandedView.style.padding = '0';
                
              } else {
                // Si no existe la vista expandida, necesitamos recrearla
                this.createExpandedView(container);
              }
              if (sliderContainer) {
                sliderContainer.style.display = 'none';
              }
            }
          }
        });
        
      } catch (error) {
        console.error('[VariantPicker] Error configurando botones Ver todos:', error);
      }
    }
    
    // Método para crear la vista expandida
    createExpandedView(container) {
      try {
        
        const slider = container.querySelector('.m-product-option--slider');
        if (!slider) {
          return null;
        }
        
        let expandedView = container.querySelector('.sabor-expanded-view');
        
        // Si ya existe, limpiarla primero
        if (expandedView) {
          expandedView.innerHTML = '';
        } else {
          expandedView = document.createElement('div');
          expandedView.className = 'm-product-option--content sabor-expanded-view';
          
          const innerElement = container.querySelector('.m-product-option__inner');
          if (innerElement) {
            innerElement.appendChild(expandedView);
          }
        }
        
        // Clonar nodos del slider
        const nodes = slider.querySelectorAll('.m-product-option--node');
        
        nodes.forEach(node => {
          const clone = node.cloneNode(true);
          
          // Vincular inputs
          const originalInput = node.querySelector('input[type="radio"]');
          const clonedInput = clone.querySelector('input[type="radio"]');
          
          if (originalInput && clonedInput) {
            clonedInput.checked = originalInput.checked;
            
            // Sincronizar cambios en el input clonado con el original
            clonedInput.addEventListener('change', () => {
              if (clonedInput.checked) {
                originalInput.checked = true;
                
                // Disparar evento para actualizar estado
                const event = new Event('change', { bubbles: true });
                originalInput.dispatchEvent(event);
              }
            });
          }
          
          expandedView.appendChild(clone);
        });
        
        // Aplicar estilos para mostrarlo
        expandedView.style.display = 'flex';
        expandedView.style.visibility = 'visible';
        expandedView.style.opacity = '1';
        expandedView.style.position = 'static';
        expandedView.style.height = 'auto';
        expandedView.style.overflow = 'visible';
        expandedView.style.marginTop = '10px';
        expandedView.style.padding = '0';
        
        
        return expandedView;
      } catch (error) {
        console.error('[VariantPicker] Error creando vista expandida:', error);
        return null;
      }
    }
    
    // Manejador para el botón Ver todos/menos
    handleViewAllButtonClick(event) {
      event.preventDefault();
      
      
      // Encontrar el contenedor asociado
      const button = event.currentTarget;
      const container = button.closest('.m-product-option--sabor');
      if (!container) {
        console.error('[VariantPicker] No se encontró el contenedor de sabor');
        return;
      }
      
      // Determinar el estado actual basado en la clase
      const isExpanded = container.classList.contains('expanded');
      
      // Crear o mostrar la vista expandida
      let expandedView = container.querySelector('.sabor-expanded-view');
      const sliderContainer = container.querySelector('.m-product-option--slider-container');
      
      if (!expandedView) {
        // Si no existe la vista expandida, crearla
        const slider = container.querySelector('.m-product-option--slider');
        if (!slider) return;
        
        expandedView = document.createElement('div');
        expandedView.className = 'm-product-option--content sabor-expanded-view';
        
        // Configurar las propiedades iniciales de posición
        expandedView.style.position = 'absolute';
        expandedView.style.height = '0';
        expandedView.style.overflow = 'hidden';
        expandedView.style.margin = '0';
        expandedView.style.padding = '0';
        
        // Clonar nodos del slider
        const nodes = slider.querySelectorAll('.m-product-option--node');
        nodes.forEach(node => {
          const clone = node.cloneNode(true);
          
          // Vincular inputs
          const originalInput = node.querySelector('input[type="radio"]');
          const clonedInput = clone.querySelector('input[type="radio"]');
          
          if (originalInput && clonedInput) {
            clonedInput.checked = originalInput.checked;
            
            // Sincronizar cambios en el input clonado con el original
            clonedInput.addEventListener('change', () => {
              if (clonedInput.checked) {
                originalInput.checked = true;
                
                // Disparar evento para actualizar estado
                const event = new Event('change', { bubbles: true });
                originalInput.dispatchEvent(event);
              }
            });
          }
          
          expandedView.appendChild(clone);
        });
        
        // Añadir al DOM
        const innerElement = container.querySelector('.m-product-option__inner');
        innerElement.appendChild(expandedView);
        
      }
      
      // Alternar la visibilidad aplicando clases CSS y manipulando directamente el estilo
      if (isExpanded) {
        button.textContent = 'Ver todos';
        container.classList.remove('expanded');
        
        // Forzar ocultación de la vista expandida mediante estilo directo
        if (expandedView) {
          expandedView.style.display = 'none';
          expandedView.style.visibility = 'hidden';
          expandedView.style.opacity = '0';
          expandedView.style.position = 'absolute';
          expandedView.style.height = '0';
          expandedView.style.overflow = 'hidden';
          expandedView.style.margin = '0';
          expandedView.style.padding = '0';
        }
        
        // Asegurar que el slider es visible
        if (sliderContainer) {
          sliderContainer.style.display = '';
        }
      } else {
        button.textContent = 'Ver menos';
        container.classList.add('expanded');
        
        // Forzar visibilidad de la vista expandida
        if (expandedView) {
          expandedView.style.display = 'flex';
          expandedView.style.visibility = 'visible';
          expandedView.style.opacity = '1';
          expandedView.style.position = 'static';
          expandedView.style.height = 'auto';
          expandedView.style.overflow = 'visible';
          expandedView.style.marginTop = '10px';
          expandedView.style.padding = '0';
        }
        
        // Asegurar que el slider está oculto
        if (sliderContainer) {
          sliderContainer.style.display = 'none';
        }
      }
      
      // Registrar estado después del cambio
      
      // Prevenir la propagación del evento para evitar conflictos
      event.stopPropagation();
    }
    
    // Guardar posiciones de slider antes de cambios
    saveSliderPositions() {
      try {
        // Encontrar contenedores de sabor
        const saborContainers = this.querySelectorAll('.m-product-option--sabor');
        if (saborContainers.length === 0) return;
        
        // Guardar estado de cada slider
        this.sliderPositions = [];
        
        saborContainers.forEach(container => {
          const sliderWrapper = container.querySelector('.m-product-option--slider-wrapper');
          if (!sliderWrapper) return;
          
          const isExpanded = container.classList.contains('expanded');
          
          // Guardar posición de scroll y estado expandido
          this.sliderPositions.push({
            container: sliderWrapper,
            scrollLeft: sliderWrapper.scrollLeft,
            expanded: isExpanded
          });
          
          // GUARDAR EN VARIABLE GLOBAL para que sobreviva a recreaciones del componente
          if (isExpanded) {
            const productId = this.dataset.productId || 'default';
            window.variantPickerExpandedState[productId] = true;
          }
          
        });
      } catch (error) {
        console.error('[VariantPicker] Error guardando posiciones:', error);
      }
    }
    
    // Restaurar posiciones de slider después de cambios
    restoreSliderPositions() {
      try {
        if (!this.sliderPositions || this.sliderPositions.length === 0) {
          return;
        }
        
        
        // Restaurar cada posición
        this.sliderPositions.forEach(position => {
          // Restaurar posición de scroll
          position.container.scrollLeft = position.scrollLeft;
          
          // Restaurar estado expandido
          const container = position.container.closest('.m-product-option--sabor');
          
          if (container) {
            const button = container.querySelector('.view-all-button');
            const expandedView = container.querySelector('.sabor-expanded-view');
            const sliderContainer = container.querySelector('.m-product-option--slider-container');
            
            
            // Establecer estado expandido/colapsado
            if (position.expanded) {
              container.classList.add('expanded');
              if (button) button.textContent = 'Ver menos';
              
              // APLICAR ESTILOS PARA MANTENER VISIBLE
              if (expandedView) {
                expandedView.style.display = 'flex';
                expandedView.style.visibility = 'visible';
                expandedView.style.opacity = '1';
                expandedView.style.position = 'static';
                expandedView.style.height = 'auto';
                expandedView.style.overflow = 'visible';
                expandedView.style.marginTop = '10px';
                expandedView.style.padding = '0';
              }
              if (sliderContainer) sliderContainer.style.display = 'none';
            } else {
              container.classList.remove('expanded');
              if (button) button.textContent = 'Ver todos';
              
              // APLICAR ESTILOS PARA OCULTAR
              if (expandedView) {
                expandedView.style.display = 'none';
                expandedView.style.visibility = 'hidden';
                expandedView.style.opacity = '0';
                expandedView.style.position = 'absolute';
                expandedView.style.height = '0';
                expandedView.style.overflow = 'hidden';
                expandedView.style.margin = '0';
                expandedView.style.padding = '0';
              }
              if (sliderContainer) sliderContainer.style.display = '';
            }
          }
        });
        
        // Limpiar posiciones guardadas
        this.sliderPositions = [];
      } catch (error) {
        console.error('[VariantPicker] Error al restaurar posiciones:', error);
      }
    }

    // Nuevo método para manejar los clics de manera directa (sin uso de bind)
    _handleViewAllClick(e) {
      // Usar una función independiente para evitar problemas con 'this'
      const button = e.currentTarget;
      const container = button.closest('.m-product-option--sabor');
      if (!container) return;
      
      const isExpanded = container.classList.contains('expanded');
      const expandedView = container.querySelector('.sabor-expanded-view');
      const sliderContainer = container.querySelector('.m-product-option--slider-container');
      
      
      if (isExpanded) {
        // Cerrar
        button.textContent = 'Ver todos';
        container.classList.remove('expanded');
        if (expandedView) {
          expandedView.style.display = 'none';
          expandedView.style.visibility = 'hidden';
          expandedView.style.opacity = '0';
          expandedView.style.position = 'absolute';
          expandedView.style.height = '0';
          expandedView.style.overflow = 'hidden';
          expandedView.style.margin = '0';
          expandedView.style.padding = '0';
        }
        if (sliderContainer) sliderContainer.style.display = '';
      } else {
        // Abrir
        button.textContent = 'Ver menos';
        container.classList.add('expanded');
        
        // Crear la vista expandida si no existe
        if (!expandedView) {
          this.handleViewAllButtonClick(e);
          return;
        }
        
        expandedView.style.display = 'flex';
        expandedView.style.visibility = 'visible';
        expandedView.style.opacity = '1';
        expandedView.style.position = 'static';
        expandedView.style.height = 'auto';
        expandedView.style.overflow = 'visible';
        expandedView.style.marginTop = '10px';
        expandedView.style.padding = '0';
        if (sliderContainer) sliderContainer.style.display = 'none';
      }
      
      
      e.stopPropagation();
    }
  }
  
  customElements.define("variant-picker", VariantPicker);
} 